import { useVisit } from '../../VisitContext';
import { FrequencyStatusEnum } from '@generated';
import { combineSieveValues } from '~/util/sieve/filter';
import { useSearch } from '~/util/http/useSearch';
import { Loading } from '~/shared/Loading';

export function NextVisit() {
	const { stayId, timeIn, performingUserId } = useVisit();
	const { data: upcomingVisits, isLoading: upcomingVisitsLoading } = useSearch({
		searchType: 'frequency',
		filters: [
			{ name: 'stayId', value: stayId, operator: '==' },
			{
				name: 'frequencyStatusId',
				operator: '==',
				value: combineSieveValues([FrequencyStatusEnum.NeedsPerformed, FrequencyStatusEnum.NeedsStaffed])
			},
			{ name: 'scheduledDateAndTime', value: timeIn, operator: '>=' }
		],
		sortColumn: 'scheduledDateAndTime',
		sortDirection: 'asc',
		page: 1,
		pageSize: 50
	});

	if (upcomingVisitsLoading) {
		return <Loading />;
	}

	const nextVisit =
		upcomingVisits.length > 0
			? upcomingVisits
					.filter(x => x.assignedToId === performingUserId)
					.sort((a, b) => new Date(a.scheduledDateAndTime).getTime() - new Date(b.scheduledDateAndTime).getTime())[0]
			: null;

	return (
		<div>
			{nextVisit ? `${nextVisit.frequencyTypeLabel} - ${nextVisit.scheduledDateAndTime.toLocaleString()}` : 'No upcoming visits scheduled'}
		</div>
	);
}
